module.exports = fox._r("fonts/kreon-regular-webfont.woff", __webpack_public_path__ + "_/_/_/common/frame/fonts/3vTADsB.woff");


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/admin/common/frame/fonts/kreon-regular-webfont.woff
// module id = 102
// module chunks = 2